import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/constants/constants';
import { ToastService } from 'src/app/service/toast.service';
import { UtilService } from 'src/app/service/util.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ApiService } from 'src/app/service/api.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-dongles',
  templateUrl: './dongles.component.html',
  styleUrls: ['./dongles.component.scss']
})
export class DonglesComponent implements OnInit {

  dongles: Array<any> = new Array();
  deviceModel: any = {};

  selectedDevices: Array<string> = new Array();

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.getDongles();
    this.initDeviceModel();
  }

  getDongles() {
    this.utilService.showSpinner();
    this.apiService.getDeviceProviderDevices().then((data) => {
      this.utilService.hideSpinner();
      this.dongles = data;
      console.log("Devices::", this.dongles);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDongles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initDeviceModel() {
    this.deviceModel = {
      "type": "DEVICE",
      "provisioningData": {
        "dongle": {
          "type": "DONGLE_DEVICE",
          "imeiId": null,
          "simId": null,
          "msisdn": null,
          "model": null,
          "firmwareVersion": null,
          "manufacturer": this.authService.accountData.name,
          "telematicsType": "AFTER_MARKET",
          "telematicsProvider": "GUIDEPOINT"
        },
        "oemId": this.authService.accountData.oemId
      }
    }
  }

  resetAddDeviceForm() {
    this.initDeviceModel();
  }

  addDevice(form: NgForm) {
    console.log("device data::", this.deviceModel);
    if (form.valid) {
      console.log("Valid data::", this.deviceModel);
      this.addProviderDevice();
    }
  }

  addProviderDevice() {
    this.utilService.showSpinner();
    this.apiService.provision(this.deviceModel).then((data) => {
      this.utilService.hideSpinner();
      console.log("add device response ::", data);
      this.toast.showSuccess("Device added successfully");
      document.getElementById("closeAddDevice").click();
      this.resetAddDeviceForm();
      this.getDongles();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addProviderDevice();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onDeviceSelected(id: string) {
    console.log("selected device id::", id);
    let itemIndex = this.selectedDevices.indexOf(id);
    if (itemIndex !== -1) {
      this.selectedDevices.splice(itemIndex, 1);
    } else {
      this.selectedDevices.push(id);
    }
    console.log("selected admins::", this.selectedDevices);
  }

  cancelDeleteDevice() {
    this.selectedDevices = [];
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  onDeleteDevices() {
    console.log("Received the request for delete devices::", this.selectedDevices);
    if (this.selectedDevices.length > 0) {
      this.utilService.showSpinner();
      this.apiService.deleteProviderDevices(this.selectedDevices).then((data) => {
        this.utilService.hideSpinner();
        if (data.length == 0) {
          this.toast.showSuccess("Device(s) Deleted successfully");
        } else {
          this.toast.showError("Delete failed for device(s) : " + data.length);
        }
        this.cancelDeleteDevice();
        this.getDongles();
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.onDeleteDevices();
          });
        } else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toast.showError(error.error.message);
          else this.toast.showError(Constants.UNKNOWN_ERROR);
        }
      });
    } else {
      this.toast.showWarning("No device selected");
    }
  }

}
